import React, {useEffect, useState} from 'react';

//styles
import './Skills.scss'

import ReactTooltip from "react-tooltip";
import {motion} from 'framer-motion';
import {AppWrap, MotionWrap} from "../../wrapper";

import {urlFor} from "../../client";

//hooks
import useFetchSanity from '../../hooks/useFetchSanity';


const Skills = () => {
    const {state: skills} = useFetchSanity('skills');
    const {state: experiences} = useFetchSanity('experiences');

    //console.log(skills);

    return (
        <>
            <h2>Skills & Experience</h2>

            <div className="app__skills-container">

                <motion.div
                    className="app__skills-lists"
                >
                    {skills.map((skill) => (
                        <motion.div
                            whileInView={{opacity: [0, 1]}}
                            transition={{duration: 0.5}}
                            className="app__skills-item app__flex"
                            key={skill.name}

                        >
                            <div
                                className="app__flex"
                                style={{backgroundColor: skill.bgColor}}
                            >
                                <img src={urlFor(skill.icon)} alt={skill.name}/>

                            </div>

                            <p className="p-text">{skill.name}</p>

                        </motion.div>
                    ))}

                </motion.div>

                {/**Experience**/}
                <motion.div
                    className="app__skills-exp"
                >

                    {experiences?.map((experience) => (
                        <motion.div
                            className="app__skills-exp-item"
                            key={experience.year}
                        >
                            <div className="app__skills-exp-year">
                                <p className="bold-text">{experience.year}</p>
                            </div>

                            <motion.div className="app__skills-exp-works">
                                {experience.works.map((work) => (
                                    <>
                                        <motion.div
                                            whileInView={{opacity: [0, 1]}}
                                            transition={{duration: 0.5}}
                                            className="app__skills-exp-work"
                                            key={work.name}
                                            data-tip
                                            data-for={work.name}
                                        >
                                            <h4 className="bold-text">{work.name}</h4>
                                            <p className="p-text">{work.company}</p>

                                        </motion.div>

                                        <ReactTooltip
                                            id={work.name}
                                            effect="solid"
                                            arrowColor="#fff"
                                            delayHide={1000}
                                            className="skills-tooltip"
                                        >
                                            {work.desc}

                                        </ReactTooltip>
                                    </>

                                ))}

                            </motion.div>

                        </motion.div>
                    ))}

                </motion.div>

            </div>
        </>
    )
}
export default AppWrap(
    MotionWrap(Skills, 'app__skills'),
    'skills',
    "app__whitebg"
);